export default __webpack_public_path__ + "static/media/laundry1-afterA-1024w.b9ea2f10.webp";